import FieldContainer from "../../../shared/containers/form/FieldContainer";
import DepartureSelectContainer from "../../../shared/containers/line_select/DepartureSelectContainer";
import JourneySelectContainer from "../../../shared/containers/line_select/JourneySelectContainer";
import ErrorContainer from "../../../shared/containers/form/ErrorContainer";
import { Label } from "../../../shared/components/form/Layout";
import { useForm } from "react-final-form";
import { MapPinIcon, ClockIcon } from "@heroicons/react/20/solid";
import Select from "../../../shared/components/form/Select";
import Input from "../../../shared/components/form/Input";

const JourneySelect = ({ className, lines, expand, departure, arrival, time }) => {
    const placeholder = "Saisissez un nom d'arrêt ou d'un lieu...";

    const form = useForm();
    const journeyField = form.getFieldState("journey");
    let departureSelect = null;
    let arrivalSelect = null;

    if (expand) {
        // 2 champs affichés
        return (
            <div className={"space-y-8"}>
                <FieldContainer form="booking_step" name="journey.departure">
                    <Label Icon={MapPinIcon}>Départ</Label>
                    <DepartureSelectContainer
                        ref={(select) => {
                            departureSelect = select;
                        }}
                        filters={{
                            lines,
                        }}
                        onChange={(value) => {
                            departure.onChange(value);
                            if (null !== value) {
                                arrivalSelect.refresh();
                            }
                        }}
                        onBlur={departure.onBlur}
                        value={departure.value}
                        placeholder={placeholder}
                        autoload={null !== departure.value}
                        focused={departure.focused}
                    />
                    <ErrorContainer form="booking_step" name="journey.departure" />
                </FieldContainer>

                <FieldContainer form="booking_step" name="journey.arrival">
                    <Label Icon={MapPinIcon}>Arrivée</Label>
                    <JourneySelectContainer
                        key={
                            journeyField &&
                            journeyField.value &&
                            journeyField.value.departure &&
                            journeyField.value.departure.id
                        }
                        ref={(select) => {
                            arrivalSelect = select;
                        }}
                        filters={{
                            departure: {
                                stopId: departure.value.id,
                                stepId: departure.value.step.id,
                            },
                            lines,
                        }}
                        className={className}
                        onChange={arrival.onChange}
                        onBlur={arrival.onBlur}
                        value={arrival.value}
                        placeholder={placeholder}
                        autoload={true}
                        focused={false}
                    />
                    <ErrorContainer form="booking_step" name="journey.arrival" />
                </FieldContainer>

                {null !== arrival.value && (
                    <FieldContainer form="booking_step" name="journey.hour">
                        <Label Icon={ClockIcon}>Heure de départ</Label>

                        <Select
                            id="hour"
                            options={Object.keys(arrival.value.journeys).map((time) => {
                                const journey = arrival.value.journeys[time];
                                return {
                                    value: journey.time.departure,
                                    label: journey.time.departure,
                                };
                            })}
                            value={{
                                value: time.value,
                                label: time.value,
                            }}
                            onChange={(value) =>
                                time.onChange(value ? value : null)
                            }
                            placeholder="Séléctionnez un horaire"
                            clearable={false}
                            searchable={false}
                        />
                        <ErrorContainer form="booking_step" name="hour" />

                        {null !== time.value && (
                            <div className="mt-7">
                                <Label Icon={ClockIcon}>Heure d'arrivée estimée</Label>
                                <Input disabled value={arrival.value.journeys[time.value].time.arrival} />
                            </div>
                        )}
                    </FieldContainer>
                )}
            </div>
        );
    }

    // 1 seul champ - tout confondu
    return (
        <FieldContainer form="booking_step" name="journey.departure">
            <Label Icon={MapPinIcon}>Départ : </Label>
            <DepartureSelectContainer
                ref={departureSelect}
                filters={{
                    lines,
                }}
                onChange={departure.onChange}
                onBlur={departure.onBlur}
                value={departure.value}
                placeholder={placeholder}
                autoload={false}
                focused={departure.focused}
            />
            <ErrorContainer form="booking_step" name="journey.departure" />
        </FieldContainer>
    );
};

export default JourneySelect;
